
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/free-form-hub",
      function () {
        return require("private-next-pages/free-form-hub/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/free-form-hub"])
      });
    }
  